// extracted by mini-css-extract-plugin
export default {"svg-icon":"dce15e","svgIcon":"dce15e","svg-icon_loader":"dab8a6","svgIconLoader":"dab8a6","rotator":"d34c91","dash":"a600cb"};